import { Tooltip } from "@mui/material";
import React from "react";

// Count on one line, disease names on a second truncated line, full list on hover.
const FindingsCell = ({ count, names = [] }) => {
  if (!count) return <span style={{ color: "#888" }}>None</span>;
  const list = names.join(", ");
  return (
    <Tooltip title={list} arrow placement="top">
      <span style={{ display: "inline-block", maxWidth: 220, verticalAlign: "middle" }}>
        <span style={{ display: "block", color: "green", fontWeight: "bold" }}>{count} found</span>
        <span
          style={{
            display: "block",
            fontSize: "0.8rem",
            color: "#555",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {list}
        </span>
      </span>
    </Tooltip>
  );
};

export default FindingsCell;
